export default function permissions() {
  const checkPermission = (
    permissions: string[], 
    permissionName: string
  ): boolean => {
	  if(typeof permissions == 'undefined') return false;
    return permissions.includes(permissionName);
  };

  return { checkPermission };
}

